import React, { useState, useMemo } from 'react';
import { useSEO } from '../../hooks/useSEO';
import { PROJECT_CATEGORIES, APP_METADATA } from '../../config/constants';
import { projectsData } from '../../Projects.data';
import PageLayout from '../../components/PageLayout/PageLayout';
import ProjectFilters from '../../components/ProjectFilters/ProjectFilters';
import ProjectCard from '../../components/ProjectCard/ProjectCard';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import '../../../src/Projects.css';

const Projects = () => {
  useSEO({
    title: 'Projects',
    description: `Explore ${projectsData.length} projects by ${APP_METADATA.author} including Full Stack, Machine Learning, IoT, and more.`,
    keywords: `${APP_METADATA.keywords}, Projects, Portfolio Projects, Software Projects`,
  });

  const [typeFilter, setTypeFilter] = useState(PROJECT_CATEGORIES.ALL);
  const [languageFilter, setLanguageFilter] = useState([]);
  const [loading, setLoading] = useState(false);

  const uniqueTechCategories = useMemo(
    () => [...new Set(projectsData.flatMap((p) => p.techCategory || []))],
    []
  );


  const handleLanguageFilterChange = (selectedTechs) => {
    setLanguageFilter(selectedTechs); // Update the languageFilter state directly
  };

  const filteredProjects = useMemo(() => {
    return projectsData.filter((p) => {
      const typeMatch = typeFilter === PROJECT_CATEGORIES.ALL || p.category === typeFilter;
      const techMatch =
        languageFilter.length === 0 ||
        languageFilter.every((tech) => p.techCategory?.includes(tech));
      return typeMatch && techMatch;
    });
  }, [typeFilter, languageFilter]);

  if (loading) {
    return <LoadingSpinner message="Loading projects..." />;
  }

  return (
    <PageLayout title="Projects">
      <ProjectFilters
        typeFilter={typeFilter}
        onTypeFilterChange={setTypeFilter}
        languageFilter={languageFilter}
        onLanguageFilterChange={handleLanguageFilterChange} // Pass the updated function
        uniqueTechCategories={uniqueTechCategories}
      />

      {filteredProjects.length === 0 ? (
        <div className="no-projects-message">
          <p>No projects found matching the selected filters.</p>
        </div>
      ) : (
        <div className="flex-gallery" role="list">
          {filteredProjects.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      )}
    </PageLayout>
  );
};

export default Projects;

